import { svg } from "lit";

export const chevronSvg = svg`
    <svg width="current" height="current" viewBox="0 0 24 25" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.3808 15.8146L3.51758 9.03254L5.14358 7.42578L12.0068 14.2078L18.8618 7.43393L20.4878 9.04069L12.0023 17.4258L10.3763 15.819L10.3808 15.8146Z"/>
    </svg>
`